import { useEffect } from 'react';

export const useGlobalEscapeKeyPress = (callback: () => void) => {
  useEffect(() => {
    const handleEscapeClick = (e: { key: string }) => {
      if (e.key === 'Escape') {
        callback?.();
      }
    };

    document.addEventListener('keydown', handleEscapeClick);

    return () => document.removeEventListener('keydown', handleEscapeClick);
  }, [callback]);
};
